const swiperKey = new Swiper('.swiper-key', {
  slidesPerView: 1,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  }
});

const swiperProdThumb = new Swiper('.swiper-prod-thumb', {
  slidesPerView: 5.5,
  spaceBetween: 10
});

const swiperProduct = new Swiper('.swiper-prod', {
  slidesPerView: 1,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  thumbs: {
    swiper: swiperProdThumb
  }
});
